/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ActivateJobDto,
  DeactivateJobDto,
  DeleteJobDto,
  GetNewEmptyJobParams,
  Job,
  JobDto,
  JobGetByIdParams,
  TriggerJobDto
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetAllUrl = () => {




  return `/api/Job/GetAll`
}

export const getAll = async ( options?: Parameters<typeof customInstance>[1]): Promise<JobDto[]> => {

  return customInstance<JobDto[]>(getGetAllUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAllQueryKey = () => {
    return [
    `/api/Job/GetAll`
    ] as const;
    }


export const getGetAllQueryOptions = <TData = Awaited<ReturnType<typeof getAll>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAll>>> = ({ signal }) => getAll({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllQueryResult = NonNullable<Awaited<ReturnType<typeof getAll>>>
export type GetAllQueryError = ErrorType<unknown>


export function useGetAll<TData = Awaited<ReturnType<typeof getAll>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAll>>,
          TError,
          Awaited<ReturnType<typeof getAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAll<TData = Awaited<ReturnType<typeof getAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAll>>,
          TError,
          Awaited<ReturnType<typeof getAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAll<TData = Awaited<ReturnType<typeof getAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAll<TData = Awaited<ReturnType<typeof getAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAllSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAll>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAll>>> = ({ signal }) => getAll({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetAllSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAll>>>
export type GetAllSuspenseQueryError = ErrorType<unknown>


export function useGetAllSuspense<TData = Awaited<ReturnType<typeof getAll>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllSuspense<TData = Awaited<ReturnType<typeof getAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllSuspense<TData = Awaited<ReturnType<typeof getAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAllSuspense<TData = Awaited<ReturnType<typeof getAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getJobGetByIdUrl = (params?: JobGetByIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Job/GetById?${stringifiedParams}` : `/api/Job/GetById`
}

export const jobGetById = async (params?: JobGetByIdParams, options?: Parameters<typeof customInstance>[1]): Promise<JobDto> => {

  return customInstance<JobDto>(getJobGetByIdUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getJobGetByIdQueryKey = (params?: JobGetByIdParams,) => {
    return [
    `/api/Job/GetById`, ...(params ? [params] : [])
    ] as const;
    }


export const getJobGetByIdQueryOptions = <TData = Awaited<ReturnType<typeof jobGetById>>, TError = ErrorType<unknown>>(params?: JobGetByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobGetById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobGetByIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobGetById>>> = ({ signal }) => jobGetById(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jobGetById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobGetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof jobGetById>>>
export type JobGetByIdQueryError = ErrorType<unknown>


export function useJobGetById<TData = Awaited<ReturnType<typeof jobGetById>>, TError = ErrorType<unknown>>(
 params: undefined |  JobGetByIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobGetById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobGetById>>,
          TError,
          Awaited<ReturnType<typeof jobGetById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobGetById<TData = Awaited<ReturnType<typeof jobGetById>>, TError = ErrorType<unknown>>(
 params?: JobGetByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobGetById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobGetById>>,
          TError,
          Awaited<ReturnType<typeof jobGetById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobGetById<TData = Awaited<ReturnType<typeof jobGetById>>, TError = ErrorType<unknown>>(
 params?: JobGetByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobGetById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useJobGetById<TData = Awaited<ReturnType<typeof jobGetById>>, TError = ErrorType<unknown>>(
 params?: JobGetByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobGetById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobGetByIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getJobGetByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof jobGetById>>, TError = ErrorType<unknown>>(params?: JobGetByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobGetById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobGetByIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobGetById>>> = ({ signal }) => jobGetById(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobGetById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type JobGetByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof jobGetById>>>
export type JobGetByIdSuspenseQueryError = ErrorType<unknown>


export function useJobGetByIdSuspense<TData = Awaited<ReturnType<typeof jobGetById>>, TError = ErrorType<unknown>>(
 params: undefined |  JobGetByIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobGetById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobGetByIdSuspense<TData = Awaited<ReturnType<typeof jobGetById>>, TError = ErrorType<unknown>>(
 params?: JobGetByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobGetById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobGetByIdSuspense<TData = Awaited<ReturnType<typeof jobGetById>>, TError = ErrorType<unknown>>(
 params?: JobGetByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobGetById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useJobGetByIdSuspense<TData = Awaited<ReturnType<typeof jobGetById>>, TError = ErrorType<unknown>>(
 params?: JobGetByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobGetById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobGetByIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetNewEmptyJobUrl = (params?: GetNewEmptyJobParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Job/GetNewEmptyJob?${stringifiedParams}` : `/api/Job/GetNewEmptyJob`
}

export const getNewEmptyJob = async (params?: GetNewEmptyJobParams, options?: Parameters<typeof customInstance>[1]): Promise<JobDto> => {

  return customInstance<JobDto>(getGetNewEmptyJobUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetNewEmptyJobQueryKey = (params?: GetNewEmptyJobParams,) => {
    return [
    `/api/Job/GetNewEmptyJob`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetNewEmptyJobQueryOptions = <TData = Awaited<ReturnType<typeof getNewEmptyJob>>, TError = ErrorType<unknown>>(params?: GetNewEmptyJobParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewEmptyJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewEmptyJobQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewEmptyJob>>> = ({ signal }) => getNewEmptyJob(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewEmptyJob>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewEmptyJobQueryResult = NonNullable<Awaited<ReturnType<typeof getNewEmptyJob>>>
export type GetNewEmptyJobQueryError = ErrorType<unknown>


export function useGetNewEmptyJob<TData = Awaited<ReturnType<typeof getNewEmptyJob>>, TError = ErrorType<unknown>>(
 params: undefined |  GetNewEmptyJobParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewEmptyJob>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewEmptyJob>>,
          TError,
          Awaited<ReturnType<typeof getNewEmptyJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewEmptyJob<TData = Awaited<ReturnType<typeof getNewEmptyJob>>, TError = ErrorType<unknown>>(
 params?: GetNewEmptyJobParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewEmptyJob>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewEmptyJob>>,
          TError,
          Awaited<ReturnType<typeof getNewEmptyJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewEmptyJob<TData = Awaited<ReturnType<typeof getNewEmptyJob>>, TError = ErrorType<unknown>>(
 params?: GetNewEmptyJobParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewEmptyJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetNewEmptyJob<TData = Awaited<ReturnType<typeof getNewEmptyJob>>, TError = ErrorType<unknown>>(
 params?: GetNewEmptyJobParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewEmptyJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewEmptyJobQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetNewEmptyJobSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getNewEmptyJob>>, TError = ErrorType<unknown>>(params?: GetNewEmptyJobParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewEmptyJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewEmptyJobQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewEmptyJob>>> = ({ signal }) => getNewEmptyJob(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewEmptyJob>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetNewEmptyJobSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getNewEmptyJob>>>
export type GetNewEmptyJobSuspenseQueryError = ErrorType<unknown>


export function useGetNewEmptyJobSuspense<TData = Awaited<ReturnType<typeof getNewEmptyJob>>, TError = ErrorType<unknown>>(
 params: undefined |  GetNewEmptyJobParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewEmptyJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewEmptyJobSuspense<TData = Awaited<ReturnType<typeof getNewEmptyJob>>, TError = ErrorType<unknown>>(
 params?: GetNewEmptyJobParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewEmptyJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewEmptyJobSuspense<TData = Awaited<ReturnType<typeof getNewEmptyJob>>, TError = ErrorType<unknown>>(
 params?: GetNewEmptyJobParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewEmptyJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetNewEmptyJobSuspense<TData = Awaited<ReturnType<typeof getNewEmptyJob>>, TError = ErrorType<unknown>>(
 params?: GetNewEmptyJobParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewEmptyJob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewEmptyJobSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getJobUpdateUrl = () => {




  return `/api/Job/Update`
}

export const jobUpdate = async (jobDto?: NonReadonly<JobDto>, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getJobUpdateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(jobDto)
  }
);}





export const getJobUpdateMutationKey = () => ['jobUpdate'] as const;

export const getJobUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobUpdate>>, TError,JobUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof jobUpdate>>, TError,JobUpdateMutationVariables, TContext> => {

const mutationKey = getJobUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof jobUpdate>>, JobUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  jobUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JobUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof jobUpdate>>>
    export type JobUpdateMutationBody = BodyType<NonReadonly<JobDto>> | undefined
    export type JobUpdateMutationError = ErrorType<unknown>
    export type JobUpdateMutationVariables = {data?: BodyType<NonReadonly<JobDto>>}

    export const useJobUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobUpdate>>, TError,JobUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof jobUpdate>>,
        TError,
        JobUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getJobUpdateMutationOptions(options), queryClient);
    }
    export const getJobCreateUrl = () => {




  return `/api/Job/Create`
}

export const jobCreate = async (jobDto?: NonReadonly<JobDto>, options?: Parameters<typeof customInstance>[1]): Promise<Job> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<Job>(getJobCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(jobDto)
  }
);}





export const getJobCreateMutationKey = () => ['jobCreate'] as const;

export const getJobCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobCreate>>, TError,JobCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof jobCreate>>, TError,JobCreateMutationVariables, TContext> => {

const mutationKey = getJobCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof jobCreate>>, JobCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  jobCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JobCreateMutationResult = NonNullable<Awaited<ReturnType<typeof jobCreate>>>
    export type JobCreateMutationBody = BodyType<NonReadonly<JobDto>> | undefined
    export type JobCreateMutationError = ErrorType<unknown>
    export type JobCreateMutationVariables = {data?: BodyType<NonReadonly<JobDto>>}

    export const useJobCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobCreate>>, TError,JobCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof jobCreate>>,
        TError,
        JobCreateMutationVariables,
        TContext
      > => {
      return useMutation(getJobCreateMutationOptions(options), queryClient);
    }
    export const getJobDeleteUrl = () => {




  return `/api/Job/Delete`
}

export const jobDelete = async (deleteJobDto?: DeleteJobDto, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getJobDeleteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deleteJobDto)
  }
);}





export const getJobDeleteMutationKey = () => ['jobDelete'] as const;

export const getJobDeleteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobDelete>>, TError,JobDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof jobDelete>>, TError,JobDeleteMutationVariables, TContext> => {

const mutationKey = getJobDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof jobDelete>>, JobDeleteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  jobDelete(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JobDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof jobDelete>>>
    export type JobDeleteMutationBody = BodyType<DeleteJobDto> | undefined
    export type JobDeleteMutationError = ErrorType<unknown>
    export type JobDeleteMutationVariables = {data?: BodyType<DeleteJobDto>}

    export const useJobDelete = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobDelete>>, TError,JobDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof jobDelete>>,
        TError,
        JobDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getJobDeleteMutationOptions(options), queryClient);
    }
    export const getTriggerOnceUrl = () => {




  return `/api/Job/TriggerOnce`
}

export const triggerOnce = async (triggerJobDto?: TriggerJobDto, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getTriggerOnceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(triggerJobDto)
  }
);}





export const getTriggerOnceMutationKey = () => ['triggerOnce'] as const;

export const getTriggerOnceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerOnce>>, TError,TriggerOnceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof triggerOnce>>, TError,TriggerOnceMutationVariables, TContext> => {

const mutationKey = getTriggerOnceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerOnce>>, TriggerOnceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  triggerOnce(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TriggerOnceMutationResult = NonNullable<Awaited<ReturnType<typeof triggerOnce>>>
    export type TriggerOnceMutationBody = BodyType<TriggerJobDto> | undefined
    export type TriggerOnceMutationError = ErrorType<unknown>
    export type TriggerOnceMutationVariables = {data?: BodyType<TriggerJobDto>}

    export const useTriggerOnce = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerOnce>>, TError,TriggerOnceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof triggerOnce>>,
        TError,
        TriggerOnceMutationVariables,
        TContext
      > => {
      return useMutation(getTriggerOnceMutationOptions(options), queryClient);
    }
    export const getActivateUrl = () => {




  return `/api/Job/Activate`
}

export const activate = async (activateJobDto?: ActivateJobDto, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getActivateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(activateJobDto)
  }
);}





export const getActivateMutationKey = () => ['activate'] as const;

export const getActivateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activate>>, TError,ActivateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activate>>, TError,ActivateMutationVariables, TContext> => {

const mutationKey = getActivateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activate>>, ActivateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  activate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateMutationResult = NonNullable<Awaited<ReturnType<typeof activate>>>
    export type ActivateMutationBody = BodyType<ActivateJobDto> | undefined
    export type ActivateMutationError = ErrorType<unknown>
    export type ActivateMutationVariables = {data?: BodyType<ActivateJobDto>}

    export const useActivate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activate>>, TError,ActivateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activate>>,
        TError,
        ActivateMutationVariables,
        TContext
      > => {
      return useMutation(getActivateMutationOptions(options), queryClient);
    }
    export const getDeactivateUrl = () => {




  return `/api/Job/Deactivate`
}

export const deactivate = async (deactivateJobDto?: DeactivateJobDto, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getDeactivateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deactivateJobDto)
  }
);}





export const getDeactivateMutationKey = () => ['deactivate'] as const;

export const getDeactivateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivate>>, TError,DeactivateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deactivate>>, TError,DeactivateMutationVariables, TContext> => {

const mutationKey = getDeactivateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivate>>, DeactivateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  deactivate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeactivateMutationResult = NonNullable<Awaited<ReturnType<typeof deactivate>>>
    export type DeactivateMutationBody = BodyType<DeactivateJobDto> | undefined
    export type DeactivateMutationError = ErrorType<unknown>
    export type DeactivateMutationVariables = {data?: BodyType<DeactivateJobDto>}

    export const useDeactivate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivate>>, TError,DeactivateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivate>>,
        TError,
        DeactivateMutationVariables,
        TContext
      > => {
      return useMutation(getDeactivateMutationOptions(options), queryClient);
    }
